export default __webpack_public_path__ + "static/media/File No. 16.6de28d23.pdf";